import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowDown",
  "use": "ArrowDown-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol viewBox=\"0 0 20 12\" id=\"ArrowDown\"><path d=\"M16.646 0L10 6.456 3.354 0 .5 2.772 10 12l9.5-9.228z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol